<div>
  <FixedPanel 
    on:closed={() => dispatch("closed")}
    title="Bajar registros desde Tremé"
    description={"Genera el esquema de base de datos y la configuración"
      +" necesaria para que el conector baje los registros desde tremé"}
    >
    
    <div slot="content">

      <!-- <Text mt="nm" nm color="body">
        {#if content && content.id}
          El conector bajará registros de 
          <Label sm px="sm" py="xs" bg="white" color="dark" rounded="xs">
            {contentTitle(content.id)}
          </Label>
        {:else}
          No se ha definido aún que registros debemos bajar
        {/if}
      </Text> -->

      <Panel mt="md" py="sm">

        <Label sm color="dark" line="tight" px="sm" vertical="middle">
          El conector bajará registros de 
        </Label>
        <Select bg="white" p="sm" 
          bind:value={content.id} 
          on:selected={(ev) => wasSelected(ev.detail)}
          {options} />
      </Panel>

      {#if content && content.id}
        <Panel mt="nm" mb="2px" ml="sm">
          <br/>
          <Label pointer bold={report==='fields'} md={report==='fields'} color="primary" bg="white" p="sm" on:click={listAllFields}>Campos</Label>
          <Label pointer bold={report==='schema'} md={report==='schema'} color="primary" bg="white" p="sm" on:click={createSchema}>Esquema</Label>
          <Label pointer bold={report==='configs'} md={report==='configs'} color="primary" bg="white" p="sm" on:click={createConfigs}>Configuración</Label>
        </Panel>
      {/if}

      <Panel bg="surface" rounded="sm" p="nm">
        {#if report==="fields" && content && content.id >= 0}
            <Panel flex items="center" justify="start" overflow="hidden">
                <Chip>Hint !</Chip>
                <Label ml="nm" sm color="dark" w="22" line="tight">
                  Elige las secciones y campos a transferir. También puedes
                  modificar el nombre de un campo o sección.
                </Label>
            </Panel>
            <SelectFields 
              meta={getRecordDefMeta(content.id)} 
              bind:selection={selectedObjs}/>
        {/if}
        
        {#if report==="schema" && content && content.id >= 0}
          <Heading>Esquema de tablas en la BD</Heading>
          <DBSchema 
            recordDef={getRecordDef(content.id)} 
            {settings}
            bind:schema={content.dbschema}/>
        {/if}
        
        {#if report==="configs" && content && content.id >= 0}
          <Heading>Configuraciones para el conector</Heading>
          <ConfigDownloadRecord 
            recordDef={getRecordDef(content.id)} 
            {settings} 
            bind:json={content.config}/>
        {/if}
      </Panel>

    </div>

  </FixedPanel>
</div>


<script context="module">
  function fillSelector(defns) {
    // only use Active and Edition forms
    defns = defns.filter((t) => ['E', 'A'].includes(t.state))

    let options = defns.map((t) => {
      return ({
        value: t.id, 
        text: t.title
      })
    })
    options = [{ value:-1, text: "Elegir" }].concat(options);

    return options;
  }
</script>


<script>
  import { onMount, createEventDispatcher, tick } from 'svelte';
  import { Panel, Select, Heading, Text, Label, Button } from 'svelte-stylo';
  import FixedPanel from '@/components/panels/FixedPanel.svelte';
  import Chip from '@/components/tags/Chip.svelte';
  import { cloned } from '@/helpers'
  import { RecordDef, is } from '@/models'
  import { recordDefsHash, recordDefsList } from '@/states/record-defs';
  import SelectFields from './SelectFields.svelte';
  import DBSchema from './DBSchema.svelte'
  import ConfigDownloadRecord from './ConfigDownloadRecord.svelte'

  export let
    settings,
    content;

  let 
    options = [],
    selected = null,
    selectedObjs = {},
    report = null;

  const dispatch = createEventDispatcher();


  onMount(() => {
    options = fillSelector(recordDefsList);
    report = 'fields';
  })


  function wasSelected(detail) {
    // alert("RecordDef selected")
    let rid = detail.value;
    if (! recordDefsHash[rid]) return null;
    selected = (rid !== -1) ? RecordDef.import(recordDefsHash[rid]) : null;
    console.log("recordDef ", selected);
    content.id = rid;
    content.resume = selected.title;
    report = null;
    dispatch("changed", content);
  }

  function getRecordDef(rid) {
    if (! recordDefsHash[rid] || rid <= 0) return null;
    return RecordDef.import(recordDefsHash[rid]);
  }

  function getRecordDefMeta(rid) {
    let rd = RecordDef.import(recordDefsHash[rid]);
    return (rd && rd.meta || null);
  }

  function contentTitle(rid) {
    if (! recordDefsHash[rid] || rid <= 0) return "";
    return recordDefsHash[rid].title;
  }

  function createSchema() {
    report = 'schema';
  }

  function createConfigs() {
    report = 'configs';
  }

  function listAllFields() {
    report = 'fields';
  }
</script>